import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getCreatorDetailsPublic({ payload: { id, signal, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.creator_object.creator_details_public,
      id,
      signal
    });

    yield put(actions.getCreatorDetailsPublicDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorDetailsPublicFailed,
      handledErrors,
      endpoint: api.creator_object.creator_details_public.url
    });
  }
}

function* getCreatorDetailsCustom({ payload: { id, signal, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.creator_object.creator_details_custom,
      id,
      signal
    });

    yield put(actions.getCreatorDetailsCustomDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorDetailsCustomFailed,
      handledErrors,
      endpoint: api.creator_object.creator_details_custom.url
    });
  }
}

function* getCreatorDetailsSendbird({ payload: { id, signal, handledErrors, onSuccess, onError } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.creator_object.creator_details_sendbird,
      id,
      signal
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.getCreatorDetailsSendbirdDone(data.result));
  } catch (error) {
    onError && onError(error);
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorDetailsSendbirdFailed,
      handledErrors,
      endpoint: api.creator_object.creator_details_sendbird.url
    });
  }
}

export const getCreatorDetailsPublicSaga = takeLatest(types.GET_CREATOR_DETAILS_PUBLIC_REQUEST, getCreatorDetailsPublic);
export const getCreatorDetailsCustomSaga = takeLatest(types.GET_CREATOR_DETAILS_CUSTOM_REQUEST, getCreatorDetailsCustom);
export const getCreatorDetailsSendbirdSaga = takeLatest(types.GET_CREATOR_DETAILS_SENDBIRD_REQUEST, getCreatorDetailsSendbird);